import { Paper, Button, Group } from '@mantine/core';
import { Divider, Stack, Title, Center } from '@mantine/core';
import ProposalTable from './ProposalTable';
import { IconPlus, IconDownload } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';
import { batchDownloadProposals } from '../../services/proposalsRoutes';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';

export default function ProposalsPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getAccessTokenSilently } = useAuth0();
  const [isBatchDownloading, setIsBatchDownloading] = useState(false);

  const handleCreateNewClick = () => {
    const newPath = `${location.pathname}/edit-proposal`;
    const newId = uuidv4();
    navigate(newPath, { state: { proposalId: newId, isNew: true } });
  };

  const handleBatchDownload = async () => {
    setIsBatchDownloading(true);
    try {
      const accessToken = await getAccessTokenSilently();
      await batchDownloadProposals(accessToken);
      notifications.show({
        title: t('success'),
        message: t('batchDownloadStarted'),
        color: 'green',
        autoClose: 3000,
        position: 'top-right',
      });
    } catch (error) {
      console.error('Batch download error:', error);
      notifications.show({
        title: t('error'),
        message: t('batchDownloadFailed'),
        color: 'red',
        autoClose: 3000,
        position: 'top-right',
      });
    } finally {
      setIsBatchDownloading(false);
    }
  };

  return (
    <Stack w="80%" align="stretch">
      <Title>{t('proposals')}</Title>
      <Divider my="lg" />
      <Group gap="md">
        <Button
          color="green"
          mt="lg"
          style={{ width: 'fit-content' }}
          leftSection={<IconPlus size={16} />}
          onClick={handleCreateNewClick}
        >
          {t('createNew')}
        </Button>
        <Button
          variant="light"
          color="blue"
          mt="lg"
          style={{ width: 'fit-content' }}
          leftSection={<IconDownload size={16} />}
          loading={isBatchDownloading}
          onClick={handleBatchDownload}
        >
          {t('downloadAllProposals')}
        </Button>
      </Group>
      <Paper withBorder={true} radius="md" p="md">
        <Center>
          <ProposalTable />
        </Center>
      </Paper>
    </Stack>
  );
}
